<template>
  <Item
    showChevron
    :isActive="filter.active && !filter.disabled"
    @click="$emit('click', filter.id)"
  >
    <template #content>
      <div class="flex items-center gap-4">
        <component
          :is="filter.icon"
          :strokeWidth="1.2"
          class="w-6 h-6 text-primary"
        />
        <span class="text-lg/normal font-medium">{{ t(filter.label) }}</span>
      </div>
    </template>
  </Item>
</template>

<script setup>
import { Item } from "@/Components/List";
import { useI18n } from "vue-i18n";

defineEmits(["click"]);

defineProps({
  filter: { type: Object, required: true },
});

const { t } = useI18n();
</script>
